import { FormControl, FormHelperText } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { ICustomField } from "@ryde/shared";

import { ProductionChainLogic } from "./production-chain.logic";
import { ProductionChainStyled } from "./production-chain.styled";

export const ProductionChainTemplate: FC<ICustomField> = props => {
  const { control } = useFormContext();

  return (
    <ProductionChainStyled>
      <Controller
        name={props.name}
        control={control}
        render={({ fieldState: { error } }) => {
          return (
            <FormControl
              error={!!error}
              data-e2e-template="production-chain-template"
            >
              <ProductionChainLogic {...props} />
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          );
        }}
      />
    </ProductionChainStyled>
  );
};
